/**
 * Module-level memory of which recent-work URLs have previously resolved via Smart Card.
 *
 * 1. Records URLs that have resolved successfully at least once.
 * 2. Lets a freshly mounted item initialise its `resolved` state to `true`, avoiding a
 *    skeleton flash when the profile card re-mounts (e.g. reopening the hover card).
 * 3. Is a no-op on the server so SSR never touches the shared set.
 */
const resolvedUrls = new Set<string>();

const isBrowser = typeof window !== 'undefined';

/** Returns whether the given URL has previously resolved successfully. */
export function hasUrlResolved(url: string | undefined): boolean {
	if (!isBrowser || !url) {
		return false;
	}
	return resolvedUrls.has(url);
}

/** Records that the given URL has resolved successfully. */
export function markUrlResolved(url: string | undefined): void {
	if (!isBrowser || !url) {
		return;
	}
	resolvedUrls.add(url);
}

/**
 * Test-only reset for the module-level cache. Do not call from production code.
 */
export function __unsafeResetResolvedUrlCache(): void {
	resolvedUrls.clear();
}
